export default function($stateProvider) {
  'ngInject';

  $stateProvider.state('payByCard', {
    component: 'fizyPaycellPayByCard',
    parent: 'buy',
    url: '/pay-by-card'
  });
}



// WEBPACK FOOTER //
// ./src/app/buy/pay-by-card/pay-by-card.routes.ts